import { HTTP } from '@/http-common'

function defaultErrorHandler (err) {
  console.log(err)
  return false
}

function getSortPath (field, type = 'asc') {
  // :type can be either 'asc' or 'desc'

  let path = ''

  if (field) {
    if (type === 'desc') {
      field = '-' + field
    }
    path += 'ordering=' + field + '&'
  }

  return path
}

function getFiltersPath (filters) {
  // :filters should be an object,
  // whose keys are field names,
  // and values are filter values,
  // e.g. filters = { user_type: 'customer' }
  let path = ''

  for (let key in filters) {
    if (filters[key] instanceof Date) {
      path += key + '=' + filters[key].toJSON() + '&'
    } else {
      if (typeof filters[key] !== 'undefined') {
        path += key + '=' + filters[key] + '&'
      } else {
        path += key + '=&'
      }
    }
  }

  return path
}

function getPaginationPath (paginate = false) {
  let path = ''

  if (paginate) {
    path += 'paginate=1&'
  }

  return path
}

function getPagePath (page = 1) {
  let path = ''

  if (page) {
    path += 'page=' + page + '&'
  }

  return path
}

function getPerPagePath (perPage = 10) {
  let path = ''

  if (perPage) {
    path += 'page_size=' + perPage + '&'
  }

  return path
}

function getCommonPath (sort = null, type = 'desc', filters = {}, pagination = false, page = 1, perPage = 10) {
  let sortPath = getSortPath(sort, type)
  let filtersPath = getFiltersPath(filters)
  let paginationPath = getPaginationPath(pagination)
  let pagePath = getPagePath(page)
  let perPagePath = getPerPagePath(perPage)

  return sortPath + filtersPath + paginationPath + pagePath + perPagePath
}

function getList (url, sort = null, type = 'desc', filters = {}, pagination = false, page = 1, perPage = 10, errorHandler = defaultErrorHandler) {
  let commonPath = getCommonPath(sort, type, filters, pagination, page, perPage)

  return HTTP.get(url + '?' + commonPath).then((response) => {
    return response
  }, (err) => {
    return defaultErrorHandler(err)
  })
}

export { defaultErrorHandler, getList, getCommonPath }



// WEBPACK FOOTER //
// ./src/services/__common.service.js